import { StrictMode } from 'react';
import { App } from './App.js';

export function MarketingRoot({ path }: { path?: string } = {}) {
  return <StrictMode>{path === undefined ? <App /> : <App path={path} />}</StrictMode>;
}
